var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.832 8.82812V2.32422H2.16797V8.82812C0.9706 8.82812 0 9.7988 0 10.9961V33.7598C0 34.3584 0.485336 34.8438 1.08398 34.8438H35.916C36.5147 34.8438 37 34.3584 37 33.7598V10.9961C37 9.7988 36.0294 8.82812 34.832 8.82812Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.916 0.15625H1.08398C0.476881 0.15625 0 0.633131 0 1.24023V10.9961H37V1.24023C37 0.633131 36.5231 0.15625 35.916 0.15625ZM11.9961 6.66016H5.49219C4.88508 6.66016 4.4082 6.18313 4.4082 5.57617C4.4082 4.96907 4.88508 4.49219 5.49219 4.49219H11.9961C12.6032 4.49219 13.0801 4.96907 13.0801 5.57617C13.0801 6.18313 12.6032 6.66016 11.9961 6.66016ZM31.5078 6.66016H18.5C17.8929 6.66016 17.416 6.18313 17.416 5.57617C17.416 4.96907 17.8929 4.49219 18.5 4.49219H31.5078C32.1149 4.49219 32.5918 4.96907 32.5918 5.57617C32.5918 6.18313 32.1149 6.66016 31.5078 6.66016ZM29.3398 13.1641H7.66016C7.061 13.1641 6.57617 13.6489 6.57617 14.248V20.752C6.57617 21.3511 7.061 21.8359 7.66016 21.8359H29.3398C29.939 21.8359 30.4238 21.3511 30.4238 20.752V14.248C30.4238 13.6489 29.939 13.1641 29.3398 13.1641ZM16.332 24.0039H7.66016C7.061 24.0039 6.57617 24.4887 6.57617 25.0879C6.57617 25.687 7.061 26.1719 7.66016 26.1719H16.332C16.9312 26.1719 17.416 25.687 17.416 25.0879C17.416 24.4887 16.9312 24.0039 16.332 24.0039ZM16.332 28.3398H7.66016C7.061 28.3398 6.57617 28.8247 6.57617 29.4238C6.57617 30.023 7.061 30.5078 7.66016 30.5078H16.332C16.9312 30.5078 17.416 30.023 17.416 29.4238C17.416 28.8247 16.9312 28.3398 16.332 28.3398ZM29.3398 28.3398H20.668C20.0688 28.3398 19.584 28.8247 19.584 29.4238C19.584 30.023 20.0688 30.5078 20.668 30.5078H29.3398C29.939 30.5078 30.4238 30.023 30.4238 29.4238C30.4238 28.8247 29.939 28.3398 29.3398 28.3398ZM29.3398 24.0039H20.668C20.0688 24.0039 19.584 24.4887 19.584 25.0879C19.584 25.687 20.0688 26.1719 20.668 26.1719H29.3398C29.939 26.1719 30.4238 25.687 30.4238 25.0879C30.4238 24.4887 29.939 24.0039 29.3398 24.0039Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 18.5,
    y1: 34.8438,
    x2: 18.5,
    y2: 2.32422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBCBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 18.5,
    y1: 30.5078,
    x2: 18.5,
    y2: 0.15625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryFilter);
export default __webpack_public_path__ + "static/media/summary-filter.fceb9993cfac08fc115b283cd52a0f80.svg";
export { ForwardRef as ReactComponent };